import React, { useEffect } from "react";
import "./aboutUs.scss";
import brandStore from "../../store/brandStore";
import { Stack } from "@mui/material";
import SEO from "components/seo/SEO";

const AboutUs = () => {
  const BrandStore = brandStore();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="about-us">
      <SEO
        title="About Us | KRISTIVE"
        description="Learn about KRISTIVE's story, our passion for perfumery, and what makes our collection special. Discover the art and craft behind every fragrance."
      />
      <div className="title">Welcome to {BrandStore.brand.brandName}</div>
      <div className="content-about-us">
        <Stack spacing={2}>
          <div>
            At KRISTIVE, we believe that everyone deserves to experience the
            power of a great fragrance. That’s why we offer a carefully selected
            range of high-quality scents that are both stylish and affordable.
            Whether you're looking for something classic, fresh, or bold, our
            collection is designed to help you express your personality through
            fragrance.
          </div>
          <div>
            Our goal is simple: to make luxury-inspired scents more accessible
            without compromising on quality.
          </div>
        </Stack>

        <div className="contact-me-on-mail">
          If you can't find something here you can always <b>Mail</b> us on{" "}
          <b>{BrandStore.brand.brandEmail}</b> for customizations.
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
